/* eslint-disable no-undef */
import { apiEndpoint, requestPayload, iFrameApiCall, isNull } from '../utils/common';
import { API, ERRORS } from '../constant';
import { payload as _payload } from './request';
import { validateMobile } from '../utils/validations';
import { post } from '../utils/http';

/**
 * Login using mobile number
 *
 * @param {number|string} mobileNumber - mobile number
 * @returns {Promise<Object>} - Promise object
 */
export function sentOtp(mobileNumber) {
  if (!mobileNumber) {
    return Promise.reject(new Error(ERRORS.MOBILE));
  }

  if (!validateMobile(mobileNumber)) {
    return Promise.reject(new Error(ERRORS.INVALID_MOBILE));
  }

  mobileNumber = mobileNumber.toString();
  return post.call(this, apiEndpoint(API.SEND_OTP), requestPayload({ mobileNumber }));
}

/**
 * OTP verification for login using mobile number
 *
 * @param {number|string} otp - otp as numeric or string
 * @param {Boolean} rememberMe - remember user or not
 * @returns {Promise<Object>} - Promise object
 */
export function validateOtp(otp, rememberMe) {
  if (!otp) {
    return Promise.reject(new Error(ERRORS.OTP));
  }

  if (isNull(rememberMe)) {
    rememberMe = false;
  }

  otp = otp.toString();

  return new Promise((resolve, reject) => {
    const payload = _payload.call(this, API.VAL_OTP);
    payload.data.body = { ...payload.data.body, otp, rememberMe, fetchCashierData: true };
    iFrameApiCall(payload)
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });

  // return post(
  //   apiEndpoint(API.VAL_OTP),
  //   requestPayload({ otp, rememberMe, fetchCashierData: true })
  // );
}

export function logout() {
  return new Promise((resolve, reject) => {
    iFrameApiCall(_payload.call(this, API.LOG_OUT))
      .then(data => resolve(data))
      .catch(err => {
        reject(err);
      });
  });
  // return post(apiEndpoint(API.LOG_OUT), requestPayload({}));
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/login.js